import React from 'react';
import { Circle } from './Circle';
import { PlusIcon } from '@iconicicons/react';

export type InsertRowProps = {
  size?: number;
  thickness?: number;
  onClick?: () => void;
};

export const InsertRow: React.FC<InsertRowProps> = ({
  size = 18,
  thickness = 3,
  onClick,
}) => {
  return (
    <div
      role="button"
      style={{
        position: 'relative',
        height: `${thickness}px`,
        border: 0,
        padding: 0,
      }}
      onClick={onClick}
      className="w-100 d-flex justify-content-center show-on-hover"
    >
      <Circle
        style={{
          position: 'absolute',
          top: `-${size / 2 - thickness / 2}px`,
          overflow: 'visible',
          padding: 1,
          backgroundColor: 'inherit',
        }}
        size={size}
        className="d-flex justify-content-center align-items-center"
      >
        <PlusIcon />
      </Circle>
    </div>
  );
};
